<mat-dialog-content>
  <div class="confrim-dialog-wrapper">
    <h2 class="cmn-popup-title">Employee Details</h2>
    <button class="cmn-close" mat-dialog-close></button>
    <div class="profile-inner-main-wrapper">
      <div class="details-wrapper">
        <h2>Full Name</h2>
        <h3>{{data?.employeeName}}</h3>
      </div>
      <div class="details-wrapper">
        <h2>Mobile Number</h2>
        <h3>{{data?.employeeData?.phoneNumber}}</h3>
      </div>
      <div class="details-wrapper">
        <h2>Email Address</h2>
        <h3>{{data?.employeeData?.email}}</h3>
      </div>
      <div class="details-wrapper">
        <h2>Date of Birth</h2>
        <h3>{{(data?.employeeData?.dateOfBirth | date: 'MMMM d, yyyy') || '--'}}</h3>
      </div>
      <div class="details-wrapper">
        <h2>Gender</h2>
        <h3>{{data?.employeeData?.gender}}</h3>
      </div>
      <!-- <div class="details-wrapper">
        <h2>Nationality</h2>
        <h3>{{data?.employeeName}}</h3>
      </div>
      <div class="details-wrapper">
        <h2>Address</h2>
        <h3>{{data?.employeeName}}</h3>
      </div>
      <div class="details-wrapper">
        <h2>Native Address</h2>
        <h3>{{data?.employeeName}}</h3>
      </div> -->
      <div class="details-wrapper">
        <h2>Employee Code</h2>
        <h3>{{data?.employeeCode}}</h3>
      </div>
      <div class="details-wrapper">
        <h2>Employee Type</h2>
        <h3>{{data?.employeeType}}</h3>
      </div>
      <div class="details-wrapper">
        <h2>Employee Status</h2>
        <h3>{{data?.employeeData?.employeeStatus}}</h3>
      </div>
      <div class="details-wrapper">
        <h2>Department</h2>
        <h3>{{data?.employeeData?.department?.departmentName}}</h3>
      </div>
      <div class="details-wrapper">
        <h2>Designation</h2>
        <h3>{{data?.employeeData?.designation?.designationName}}</h3>
      </div>
      <!-- <div class="details-wrapper">
        <h2>Joining Date</h2>
        <h3>
          {{data?.employeeName}}
        </h3>
      </div> -->
    </div>

    <div class="submit-btn-wrapper">
      <button class="cmn-cancel-btn" (click)="onCancel()">Cancel</button>
    </div>
  </div>
</mat-dialog-content>